<script setup lang="ts">
const companyInfo = useCompanyInfo()
</script>

<template>
    <address>
        {{ companyInfo.name }}<br>
        {{ companyInfo.street }}<br>
        {{ companyInfo.postalCode }} {{ companyInfo.city }}<br>
        {{ $t('email') }}: {{ companyInfo.email }}<br>
        {{ $t('phone') }}: <i18n-t keypath="if-you-would-like-to-contact-us-by-telephone" tag="i">
            <tw-link-support-form />
        </i18n-t>
    </address>
</template>

<style lang="scss" scoped>
address {
    font-style: normal;
}
</style>